var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShippingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 12.6667V1.46667C11.8 1.20893 11.5985 1 11.35 1H1.45C1.20147 1 1 1.20893 1 1.46667V12.6667C1 12.9244 1.20147 13.1333 1.45 13.1333H2.8M11.8 12.6667C11.8 12.9244 11.5985 13.1333 11.35 13.1333H6.4M11.8 12.6667V4.26667C11.8 4.00893 12.0015 3.8 12.25 3.8H15.2136C15.333 3.8 15.4474 3.84917 15.5318 3.93668L18.8682 7.39665C18.9526 7.48417 19 7.60287 19 7.72663V12.6667C19 12.9244 18.7985 13.1333 18.55 13.1333H17.2M11.8 12.6667C11.8 12.9244 12.0015 13.1333 12.25 13.1333H13.6M2.8 13.1333C2.8 14.1643 3.60589 15 4.6 15C5.59411 15 6.4 14.1643 6.4 13.1333M2.8 13.1333C2.8 12.1024 3.60589 11.2667 4.6 11.2667C5.59411 11.2667 6.4 12.1024 6.4 13.1333M13.6 13.1333C13.6 14.1643 14.4059 15 15.4 15C16.3941 15 17.2 14.1643 17.2 13.1333M13.6 13.1333C13.6 12.1024 14.4059 11.2667 15.4 11.2667C16.3941 11.2667 17.2 12.1024 17.2 13.1333",
    stroke: "#3C4242",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingIcon);
export default __webpack_public_path__ + "static/media/shipping_icon.cc8d44f504826f80238459cc87dfd1d1.svg";
export { ForwardRef as ReactComponent };